<mat-icon class="sun-icon align-middle">wb_sunny</mat-icon>
<div class="all">
    {{solarSystem.name}}
    <div class="sp-buttons">
        <button [disabled]="!solarSystem.canEdit" mat-icon-button (click)="handleEditSolarSystem()"><mat-icon>edit</mat-icon></button>
        <button [disabled]="!solarSystem.canDelete" mat-icon-button (click)="handleDeleteSolarSystem()"><mat-icon>delete</mat-icon></button>
    </div>
</div>
